'use client';

import { Divider, Typography } from '@musinsa/mds';
import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';
import type { RevenuePlatform } from '../../query-factory/revenue.factory';

const StatItem = ({ label, value }: { label: string; value: string }) => (
  <div className="flex items-center justify-between py-1">
    <Typography size="13" weight="regular" colorScheme="black">
      {label}
    </Typography>
    <Typography size="13" weight="regular" colorScheme="black" className="text-right">
      {value}
    </Typography>
  </div>
);

interface EarningsSummarySectionProps {
  year: number | null;
  month: number | null;
  platform: RevenuePlatform;
}

export const EarningsSummarySection = ({ year, month, platform }: EarningsSummarySectionProps) => {
  const { data: revenueData } = useQuery({
    ...curatorQueries.revenue.monthlyRevenue(year!, month!, platform),
    enabled: year !== null && month !== null,
  });

  const { period, totalStats } = revenueData || {
    period: { dateRange: '-', isConfirmed: false },
    totalStats: {
      orderCount: 0,
      orderAmount: '0원',
      earnings: '0원',
      visitCount: 0,
    },
  };

  return (
    <div className="bg-white px-4 pt-3">
      <div className="flex items-center justify-between pt-3 pb-1">
        <Typography size="13" weight="regular" colorScheme="black">
          집계 기간
        </Typography>
        <Typography size="13" weight="regular" colorScheme="black" className="text-right">
          {period.dateRange}
        </Typography>
      </div>

      <StatItem label="총 방문" value={`${totalStats.visitCount.toLocaleString()}회`} />

      <StatItem label="총 결제 건" value={`${totalStats.orderCount.toLocaleString()}건`} />

      <StatItem label="총 결제 금액" value={totalStats.orderAmount} />

      <div className="flex items-center justify-between py-3">
        <Typography size="14" weight="semiBold" colorScheme="black">
          {period.isConfirmed ? '총 확정 수익' : '총 예상 수익'}
        </Typography>
        <Typography size="14" weight="semiBold" colorScheme="black" className="text-right">
          {totalStats.earnings}
        </Typography>
      </div>

      <div className="py-3">
        <Divider variant="line" />
      </div>
    </div>
  );
};
